import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'

interface ReferToEmailStepProps {
    email: string
}

const ReferToEmailStep: React.FC<ReferToEmailStepProps> = ({ email }) => {
    return (
        <Box>
            <Stack spacing={2}>
                <Typography color="info" align="center">
                    <Trans i18nKey="login.refer_to_email_step.message" values={{ email }}>
                        Er is een email verstuurd naar: <strong>{email}</strong>
                        <br />
                        Volg de instructies in je email <br />
                        Je kunt dit venster sluiten.
                    </Trans>
                </Typography>
            </Stack>
        </Box>
    )
}

export default ReferToEmailStep
